import fetch from '@/utils/fetch';
const api_url = process.env.VUE_APP_API;

//新建应用 编辑应用
export const new_app = data => fetch({//手机号密码登录
  url: `${api_url}/app`,
  method: 'post',
  data ,
});

//获取应用列表
export const app_list = () => fetch({//组织页顶部信息
  url: `${api_url}/app`,
});

export const get_id = () => fetch({//banner上传图片
  url: `${api_url}/auth`,
});

export const app_get_id = (data) => fetch({
  url: `${api_url}/app/${data.id}`,
});

export const deleteApp = data => fetch({//删除app
  url: `${api_url}/app/${data.id}`,
  method: 'delete',
  data ,
});

export const countTimes = data => fetch({
  url: `${api_url}/app/count/${data.id}/${data.type}`,
  method: 'put',
  data ,
});